import { Info } from './types/Info';

export default {
    Info
}